const education = (isAuthenticated) => [
    {
        path: "/:lang?/bonuses",
        name: "bonuses",
        component: () => import("@/modules/education/pages/view/index.vue"),
        beforeEnter: isAuthenticated,
        meta: {
            isChildrenRoute: false,
            breadcrumbs: [
                {
                    bcDynamic: false,
                    bcLabel: "main",
                    name: "courses",
                },
                {
                    bcDynamic: false,
                    bcLabel: "bonuses",
                    name: "bonuses",
                },
            ],
        },
    },
    {
        path: "/:lang?/bonuses/:slug",
        name: "bonuses-detail",
        component: () => import("@/modules/education/pages/detail/index.vue"),
        beforeEnter: isAuthenticated,
        meta: {
            isChildrenRoute: true,
            breadcrumbs: [
                {
                    bcDynamic: false,
                    bcLabel: "main",
                    name: "courses",
                },
                {
                    bcDynamic: false,
                    bcLabel: "bonuses",
                    name: "bonuses",
                },
                {
                    bcDynamic: true,
                    bcModule: "education",
                    bcGetter: "currentItem",
                    name: "education-detail",
                },
            ],
        },
    },
    {
        path: "/:lang?/qa-sessions",
        name: "qa-sessions",
        component: () => import("@/modules/education/pages/view/index.vue"),
        beforeEnter: isAuthenticated,
        meta: {
            isChildrenRoute: false,
            breadcrumbs: [
                {
                    bcDynamic: false,
                    bcLabel: "main",
                    name: "courses",
                },
                {
                    bcDynamic: false,
                    bcLabel: "qa-sessions",
                    name: "qa-sessions",
                },
            ],
        },
    },
    {
        path: "/:lang?/qa-sessions/:slug",
        name: "qa-sessions-detail",
        component: () => import("@/modules/education/pages/detail/index.vue"),
        beforeEnter: isAuthenticated,
        meta: {
            isChildrenRoute: true,
            breadcrumbs: [
                {
                    bcDynamic: false,
                    bcLabel: "main",
                    name: "courses",
                },
                {
                    bcDynamic: false,
                    bcLabel: "qa-sessions",
                    name: "qa-sessions",
                },
                {
                    bcDynamic: true,
                    bcModule: "education",
                    bcGetter: "currentItem",
                    name: "qa-sessions-detail",
                },
            ],
        },
    },
    {
        path: "/:lang?/webinars",
        name: "webinars",
        component: () => import("@/modules/education/pages/view/index.vue"),
        beforeEnter: isAuthenticated,
        meta: {
            isChildrenRoute: false,
            breadcrumbs: [
                {
                    bcDynamic: false,
                    bcLabel: "main",
                    name: "courses",
                },
                {
                    bcDynamic: false,
                    bcLabel: "webinars",
                    name: "webinars",
                },
            ],
        },
    },
    {
        path: "/:lang?/webinars/:slug",
        name: "webinars-detail",
        component: () => import("@/modules/education/pages/detail/index.vue"),
        beforeEnter: isAuthenticated,
        meta: {
            isChildrenRoute: true,
            breadcrumbs: [
                {
                    bcDynamic: false,
                    bcLabel: "main",
                    name: "courses",
                },
                {
                    bcDynamic: false,
                    bcLabel: "webinars",
                    name: "webinars",
                },
                {
                    bcDynamic: true,
                    bcModule: "education",
                    bcGetter: "currentItem",
                    name: "webinars-detail",
                },
            ],
        },
    },
    {
        path: "/:lang?/stream",
        name: "streams-detail",
        component: () => import("@/modules/education/pages/stream-detail/index.vue"),
        beforeEnter: isAuthenticated,
        meta: {
            isChildrenRoute: false,
            breadcrumbs: [
                {
                    bcDynamic: false,
                    bcLabel: "main",
                    name: "courses",
                },
                {
                    bcDynamic: false,
                    bcLabel: "streams",
                    name: "streams",
                },
            ],
        },
    },
    {
        path: "/:lang?/master-classes",
        name: "master-classes",
        component: () => import("@/modules/education/pages/view/index.vue"),
        beforeEnter: isAuthenticated,
        meta: {
            isChildrenRoute: false,
            breadcrumbs: [
                {
                    bcDynamic: false,
                    bcLabel: "main",
                    name: "courses",
                },
                {
                    bcDynamic: false,
                    bcLabel: "master-classes",
                    name: "master-classes",
                },
            ],
        },
    },
    {
        path: "/:lang?/master-classes/:slug",
        name: "master-classes-detail",
        component: () => import("@/modules/education/pages/detail/index.vue"),
        beforeEnter: isAuthenticated,
        meta: {
            isChildrenRoute: true,
            breadcrumbs: [
                {
                    bcDynamic: false,
                    bcLabel: "main",
                    name: "courses",
                },
                {
                    bcDynamic: false,
                    bcLabel: "master-classes",
                    name: "master-classes",
                },
                {
                    bcDynamic: true,
                    bcModule: "education",
                    bcGetter: "currentItem",
                    name: "master-classes-detail",
                },
            ],
        },
    },
    {
        path: "/:lang?/action-plans",
        name: "action-plans",
        component: () => import("@/modules/action-plans/pages/main/index.vue"),
        meta: {
            isChildrenRoute: false,
            breadcrumbs: [
                {
                    bcDynamic: false,
                    bcLabel: "main",
                    name: "courses",
                },
                {
                    bcDynamic: false,
                    bcLabel: "action-plans",
                    name: "action-plans",
                },
            ],
        },
    },
    {
        path: "/:lang?/action-plans/:slug",
        name: "action-plans-detail",
        component: () => import("@/modules/action-plans/pages/detail/index.vue"),
        meta: {
            isChildrenRoute: true,
            breadcrumbs: [
                {
                    bcDynamic: false,
                    bcLabel: "main",
                    name: "courses",
                },
                {
                    bcDynamic: false,
                    bcLabel: "action-plans",
                    name: "action-plans",
                },
                {
                    bcDynamic: true,
                    bcModule: "actionPlans",
                    bcGetter: "currentItem",
                    name: "action-plans-detail",
                },
            ],
        },
    },
    // Deprecated "tests" section — students still land here via old/bookmarked
    // links. Redirect the listing and any deep test page to the course catalog.
    {
        path: "/:lang?/tests",
        name: "tests",
        redirect: (to) => ({ name: "courses", params: { lang: to.params.lang } }),
    },
    {
        path: "/:lang?/tests/:testId/rules",
        name: "tests-rules",
        redirect: (to) => ({ name: "courses", params: { lang: to.params.lang } }),
    },
    {
        path: "/:lang?/tests/:testId/check",
        name: "tests-check",
        redirect: (to) => ({ name: "courses", params: { lang: to.params.lang } }),
    },
    {
        path: "/:lang?/tests/:testId/questions",
        name: "tests-questions",
        redirect: (to) => ({ name: "courses", params: { lang: to.params.lang } }),
    },
    {
        path: "/:lang?/tests/:testId/report",
        name: "tests-report",
        redirect: (to) => ({ name: "courses", params: { lang: to.params.lang } }),
    },
];

export default education;
